import styled from "styled-components";

export const StyledPromptItem = styled.div<{ selected: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  margin: 5px 0;
  background-color: ${({ selected }) => (selected ? "#e0e0e0" : "#fff")};
  cursor: pointer;
  height: 50px; /* Aumentar a altura */
`;

export const Title = styled.span`
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const IconsContainer = styled.div`
  display: flex;
  gap: 10px;
`;

export const IconButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  color: #333;
`;
